import React from 'react';
import { FaPlus } from 'react-icons/fa';
import '../styles/Blog.css';

const AdminBlog = () => {
  const posts = ['5 Signs Your Home Needs Rewiring','Benefits of Solar Panels','Choosing CCTV Systems','Electrical Safety Tips','Smart Home Technology','Cost Guide: Installation','Professional Network Setup','Solar System Maintenance'];
  return (
    <div className="blog-page">
      <h1>Blog Posts</h1>
      <p>Manage your blog articles.</p>
      <button className="add-btn"><FaPlus /> Add New Post</button>
      <table className="blog-table">
        <thead><tr><th>#</th><th>Title</th><th>Category</th><th>Date</th><th>Actions</th></tr></thead>
        <tbody>{posts.map((p,i)=>(<tr key={i}><td>{i+1}</td><td>{p}</td><td>Electrical Tips</td><td>April 2026</td><td><button className="edit-btn">Edit</button> <button className="delete-btn">Delete</button></td></tr>))}</tbody>
      </table>
    </div>
  );
};
export default AdminBlog;
